module.exports = __webpack_public_path__ + "img/logorealtec.f435dbc0.png";